import { canv } from "@/canv/global";
import { MindMapWidget } from "@/elements/mindMap";
import { MindMapWidgetNode } from "@/elements/mindMap/node";
import type { TreeNodeWidget } from "@/elements/treeNode";
import { Group } from "@/group";
import { generateKeyBetween } from "@/helpers/fractional-indexing";

export function replaceMindMaps() {
    const allTreeNodes: TreeNodeWidget[] = [];

    for (let i = 0; i < canv.canvasController.items.length; i++) {
        canv.canvasController.items[i].collectTreeNodes(allTreeNodes);
    }

    const rootTreeNodes: TreeNodeWidget[] = [];

    for (let i = 0; i < allTreeNodes.length; i++) {
        if (allTreeNodes[i].direction === "" || allTreeNodes[i].parentNode === "") {
            rootTreeNodes.push(allTreeNodes[i]);
        }
    }

    for (let i = 0; i < rootTreeNodes.length; i++) {
        replaceMindMapsOne(rootTreeNodes[i]);
    }
}

export function replaceMindMapsOne(rootTreeNode: TreeNodeWidget) {
    const rootState = rootTreeNode.getState("full");
    const nodesStates: Array<typeof rootState> = [];

    rootState.level = generateKeyBetween(null, null);
    nodesStates.push(rootState);
    rootTreeNode.collectChildren(nodesStates);

    const newMindMapWidget = new MindMapWidget(0, 0);

    newMindMapWidget.nodes = [];

    for (let i = 0; i < nodesStates.length; i++) {
        const newNode = new MindMapWidgetNode(0, 0);

        newNode.UID = nodesStates[i].UID; // тут оставляем UID, это был UID of entity, а теперь UID ноды в mindMap. Пересечься не могут
        newNode.startX = nodesStates[i].startX;
        newNode.startY = nodesStates[i].startY;
        newNode.level = nodesStates[i].level || "";
        newNode.textPart.loadState(nodesStates[i].textPart, "full");
        newNode.parentNodeUID = nodesStates[i].parentNode;

        if (nodesStates[i].direction === "right") {
            newNode.direction = "direct";
        } else if (nodesStates[i].direction === "left") {
            newNode.direction = "reverse";
        } else {
            newNode.direction = "";
        }

        newNode.updateDims();
        newMindMapWidget.nodes.push(newNode);
    }

    newMindMapWidget.alignMindMap();

    canv.eventManager.openRecord();
    canv.canvasController.deleteProcessor(rootTreeNode.parent as unknown as Group);
    canv.eventManager.closeRecord();

    const newGroup = new Group(true);

    newMindMapWidget.setParent(newGroup);
    canv.canvasController.addGroup(newGroup);

    canv.eventManager.openRecord();
    canv.eventManager.createBuildEvent("create", newGroup);
    canv.eventManager.closeRecord();
}
